module.exports = __webpack_public_path__ + "static/fonts/iconfont.32dec2d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.ttf?t=1560845219567
// module id = 6IYY
// module chunks = 61